import { useSortable } from '@dnd-kit/sortable';

import { DragHandle } from '@ui/components/DragHandle/DragHandle';

type Props = {
  id: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
};
export function DragHandleWidget({ id, className, onClick, disabled }: Props) {
  const { listeners, setActivatorNodeRef, attributes } = useSortable({
    id,
    disabled,
  });

  return (
    <DragHandle
      className={className}
      ref={setActivatorNodeRef}
      {...listeners}
      {...attributes}
      onClick={onClick}
      disabled={disabled}
    />
  );
}
